import React, { useState, useRef } from 'react'
import "./index.css";
import Timer from "../../timer/timer";
import Video from '../../video/video';
import Audio from '../../audio/audio';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: 'none',
        border: 'none',
    },
};

const FinalPuzzleIntro = (props) => {
    const actorName1 = "ERIK";
    const actorTitle1 = "Ghost Chef";
    const actorName2 = "BILLIE";
    const actorTitle2 = "Carnival Baker";
    const actorName3 = "PATTY";
    const actorTitle3 = "Horse Trainer";
    const playVideo1 = useRef(null);
    const playVideo2 = useRef(null);
    const playVideo3 = useRef(null);
    const timerRef = useRef(null);

    const playAudio = useRef(null);

    //const posterURL1 = './actors/Erik.png';

    const posterURL1 = './actors/Black_BG.jpg';
    const posterURL2 = './actors/Billie.png';
    const posterURL3 = './actors/Patty.png';

    const actor1IntroVideo = './videos/7_1_Finale_02.mp4';
    const actor2IntroVideo = './videos/7_1_Finale_03.mp4';
    const actor3IntroVideo = './videos/7_1_Finale_04.mp4';

    const [currentVideoURL, setCurrentVideoURL] = useState(actor1IntroVideo);

    //modal

    const [gameOverModalIsOpen, setGameOverModalIsOpen] = useState(false);

    function openGameOverModal() {
        setGameOverModalIsOpen(true);
    }

    function closeGameOverModal() {
        timerRef.current(props.initialTimeOut);
        setGameOverModalIsOpen(false);
    }
    function restartGame() {
        setGameOverModalIsOpen(false);
        props.goToStep(null, 'LandingPage');

    }

    //modal end

    const gotoFailed = (event, args) => {
        if (gameOverModalIsOpen) {

        } else {
            openGameOverModal();
        }

    }

    const updateVideoStatue = (value, src) => {

        if (value === "ended") {
            if (currentVideoURL === actor3IntroVideo) {
                props.goToStep(null, 'FinalPuzzle');
            } else if (currentVideoURL === actor1IntroVideo) {
                setCurrentVideoURL(actor2IntroVideo);
                playVideo2.current(actor2IntroVideo);
            } else if (currentVideoURL === actor2IntroVideo) {
                setCurrentVideoURL(actor3IntroVideo);
                playVideo3.current(actor3IntroVideo);
            } else {
                setCurrentVideoURL(actor1IntroVideo);
                playVideo1.current(actor1IntroVideo);
            }

        }

    }

    const updateAudioStatue = (value) => {

    }

    const setUpWarningSound = () => {
        if (playAudio.current) {
            playAudio.current('./musics/30SecondTimer.mp3');
        }
    }


    return (<>
        <div className="finalPuzzleIntro">
            <div className='headerRow'>
                <div className='pgTitle'>
                    <div className='gameTitleContainer'>
                        <div className='pgDesc'>Final Puzzle</div>
                    </div>
                   
                </div>
               
                <Timer seconds={props.seconds} gotoFailed={gotoFailed} isReversed={props.isReversed} setUpWarningSound={setUpWarningSound} timerRef={timerRef} updateTimerValue={props.updateTimerValue} />

            </div>
            <div className='introVideoContainer'>
                <Video VideoURL="./videos/7_1_Finale_02.mp4" actorName={actorName1} actorTitle={actorTitle1} poster={posterURL1} updateVideoStatue={updateVideoStatue} playVideo={playVideo1} />
                <Video VideoURL="" actorName={actorName2} autoPlay={false} actorTitle={actorTitle2} poster={posterURL2} updateVideoStatue={updateVideoStatue} playVideo={playVideo2} />
                <Video VideoURL="" actorName={actorName3} autoPlay={false} actorTitle={actorTitle3} poster={posterURL3} updateVideoStatue={updateVideoStatue} playVideo={playVideo3} />
            </div>
            <Modal
                isOpen={gameOverModalIsOpen}
                style={customStyles}
                contentLabel="Game over"
            >
                <div className="timeOutPopup">
                    <div className='timeoutContainer'>
                        <div className='timeoutLabel' />
                        <div className='paperContainer' />
                        <div className='timeoutPictures'>
                            <div className='pic1'></div>
                            <div className='pic2'></div>
                            <div className='pic3'></div>
                        </div>
                        <div className='timeoutMessage'>
                            Oops you've run out of time!
                        </div>
                        <div className='timoutButtonsContainer'>
                            <button className='timeoutButton' onClick={closeGameOverModal} >Continue?</button>
                            <button className='timeoutButton' onClick={restartGame}>Restart</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />

        </div>
    </>
    );
}

export default FinalPuzzleIntro;